export default __webpack_public_path__ + "static/media/river.84219070.gif";